import Button from "@mui/material/Button/Button"
import { ActionSheetRef } from "actionsheet-react"
import { useHistory } from "react-router"
import Logger from "../services/Logger"
import { IMChatStore } from "../stores/IMChatStore"

const BlockActionSheet = (props:{store: IMChatStore, ref?: ActionSheetRef})=>{

    const history = useHistory()

    async function blockUser(reported = false){
        try {
           await props.store.blockUser(reported)
            //...Additional logic to handle a block
            props.ref?.close()
            props.store.deleteChat()
            history.goBack()

        } catch (err) {
            Logger.err(err, 'BLOCK_ERR')
        }
    }

    return(
        <div className='flex-column center-both' style={{padding: 12}} >
            <Button key={1} variant="outlined" style={{marginBottom: 12}} onClick={ ()=>blockUser()} >Block</Button>
            <Button key={2} variant="outlined" onClick={()=>blockUser(true)} >Block and Report</Button>
        </div>
    )
}

export default BlockActionSheet